import { render } from "./CalendarEventDetails.vue?vue&type=template&id=7dbbd572"
import script from "./CalendarEventDetails.vue?vue&type=script&lang=ts"
export * from "./CalendarEventDetails.vue?vue&type=script&lang=ts"
script.render = render

export default script